import { Box } from '@mui/material';

import { Outlet } from 'react-router-dom';

import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header';
import useAppStore from '@/store/app';
import useCanonical from '@/hooks/useCanonical';

export default function PublicLayout() {
  const { dialogForm } = useAppStore();

  if (import.meta.env.NODE_ENV !== 'production') {
    useCanonical();
  }

  return (
    <Box
      sx={{
        width: '100vw',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'normal',
        zIndex: 1202,
      }}
    >
      <Header />
      {dialogForm && dialogForm}
      <Outlet />
      <Footer />
    </Box>
  );
}
